import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { ClientOpenQuoteWrapper } from '@app/pages/quote/open-quote/clients/client-wrapper.component';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-client-open-mobile',
  templateUrl: './client-open-mobile.component.html',
  styleUrls: ['./client-open-mobile.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ClientOpenMobileComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ClientOpenMobileComponent),
      multi: true,
    },
  ],
})
export class ClientOpenMobileComponent extends ClientOpenQuoteWrapper {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}
